import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import { Brand } from "@/components/Brand";

// Legal entity details, as on the MCA Certificate of Incorporation. Meta / Razorpay business verification
// compare these against the registration documents, so keep the name and address exactly as registered.
export const COMPANY = {
  name: "Innovate Dentistry LLP",
  llpin: "ABC-2328",
  address: "32/95, Surabhi, Kottavalappu, Adkathbail, Kasaragod, Kerala, India – 671121",
  email: "thejus@dentmemo.in",
  phone: "+91 91774 00639",
};

export const LEGAL_LINKS = [
  ["Privacy", "/privacy"],
  ["Terms", "/terms"],
  ["Data deletion", "/data-deletion"],
];

export const Phone = () => (
  <a href={`tel:${COMPANY.phone.replace(/\s/g, "")}`} className="font-semibold text-slate-900 underline underline-offset-2">{COMPANY.phone}</a>
);

export const Mail = () => (
  <a href={`mailto:${COMPANY.email}`} className="font-semibold text-slate-900 underline underline-offset-2">{COMPANY.email}</a>
);

/** Company identification block shown in every public footer. */
export const CompanyInfo = ({ className = "" }) => (
  <div className={`space-y-1 text-xs leading-relaxed text-slate-500 ${className}`}>
    <p>© {new Date().getFullYear()} DentMemo. Powered by {COMPANY.name} (LLPIN {COMPANY.llpin}). Made in India.</p>
    <p>Registered office: {COMPANY.address}</p>
    <p>
      Contact: <a href={`mailto:${COMPANY.email}`} className="hover:text-slate-900">{COMPANY.email}</a>
      {" · "}<a href={`tel:${COMPANY.phone.replace(/\s/g, "")}`} className="hover:text-slate-900">{COMPANY.phone}</a>
    </p>
  </div>
);

export const Part = ({ title, children }) => (
  <section className="mt-10">
    <h2 className="font-head text-xl font-extrabold tracking-tight text-slate-900">{title}</h2>
    <div className="mt-3 space-y-3">{children}</div>
  </section>
);

export const List = ({ items }) => (
  <ul className="list-disc space-y-2 pl-5">
    {items.map(([lead, rest]) => <li key={lead}><span className="font-semibold text-slate-800">{lead}</span> {rest}</li>)}
  </ul>
);

/** Shared layout for the public legal pages (privacy, terms, data deletion). */
export function LegalPage({ title, updated, testId, children }) {
  useEffect(() => { document.title = `${title} · DentMemo`; return () => { document.title = "DentMemo"; }; }, [title]);

  return (
    <div className="min-h-screen text-slate-900">
      <header className="border-b border-slate-200/70 bg-[#f8fafc]/85">
        <div className="mx-auto flex h-16 w-full max-w-3xl items-center justify-between px-5 sm:px-8">
          <Link to="/" aria-label="DentMemo home"><Brand /></Link>
          <Link to="/login" className="dm-btn-quiet">Log in</Link>
        </div>
      </header>

      <main className="mx-auto w-full max-w-3xl px-5 pb-20 pt-12 text-[15px] leading-relaxed text-slate-600 sm:px-8" data-testid={testId}>
        <h1 className="font-head text-3xl font-extrabold tracking-tight text-slate-900 sm:text-4xl">{title}</h1>
        {updated && <p className="mt-2 text-sm text-slate-500">Last updated {updated}</p>}
        {children}
      </main>

      <footer className="border-t border-slate-200">
        <div className="mx-auto flex w-full max-w-3xl flex-col gap-5 px-5 py-8 sm:px-8">
          <div className="flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between">
            <Brand />
            <nav className="flex flex-wrap gap-x-5 gap-y-2 text-sm text-slate-600">
              <Link to="/" className="hover:text-slate-900">Home</Link>
              {LEGAL_LINKS.map(([l, h]) => <Link key={h} to={h} className="hover:text-slate-900">{l}</Link>)}
            </nav>
          </div>
          <CompanyInfo />
        </div>
      </footer>
    </div>
  );
}
